// ==============================
//* PRODUCT LIST TILE / MARKETING TILE
//
//? This file manages marketing tile in plp.
// ==============================

const setupMarketingTile = {
    selectors: {
        marketingTiles: ".marketing-tile"
    },

    init() {
        let $marketingTile = $(this.selectors.marketingTiles);
        $marketingTile.each(function (index) {
            if ($(this).hasClass("shapeimage")) {
                let $bkgColor = $(this).data("bkg");
                let $bkgGradient = $(this).data("gradient");
                let $bkgR = hexToRgb($bkgColor).r;
                let $bkgG = hexToRgb($bkgColor).g;
                let $bkgB = hexToRgb($bkgColor).b;

                if ($bkgGradient === true) {
                    $($marketingTile[index]).css("background-image", "linear-gradient(" + $bkgColor + " 0%, rgba(" + $bkgR + "," + $bkgG + "," + $bkgB + ",.2) 100%");
                } else {
                    $($marketingTile[index]).css("background", $bkgColor);
                }
            } else {
                let $bkgImg = $($marketingTile[index]).data("image");
                $($marketingTile[index]).css("background-image", "url(" + $bkgImg + ")");
            }
        });
    }
};
setupMarketingTile.init();

/**
 *
 * @param {string} hex code hexadecimal return rgb color
 * @returns {number} rgb color
 */
function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
